export default {
    authConfigDetail: '/auth/userPermission/getDetail', //用户权限配置--获取权限详情
    authConfigDelete: '/auth/userPermission/deletePermission', //用户权限配置--权限删除
    authConfigBind: '/auth/userPermission/permissionChangeNotify', //用户权限配置--发送钉钉通知
    updateAuthConfig: '/auth/userPermission/updatePermission', //用户权限配置--更新单独的权限
    updateUseBasicDetail: '/auth/userPermission/updateUseBasicDetail', //用户权限配置--保存
    
  };
  


// WEBPACK FOOTER //
// ./src/api/authConfig.js